/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  POST_ACES_CHAP_WAITLIST_ENROLL,
  FETCH_ACES_CHAP_WAITLIST_APPLIED,
  FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE,
  POST_ACES_CHAP_WAITLIST_SUBMIT_FORM,
} from './actionTypes';

/**
 * Updates the details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesChapWaitlistEnrollReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_CHAP_WAITLIST_ENROLL);

/**
 * Updates the indicator of creation of details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesChapWaitlistEnrollReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_CHAP_WAITLIST_ENROLL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesChapWaitlistEnrollErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_CHAP_WAITLIST_ENROLL);

/**
 * Updates the details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesChapWaitlistAppliedReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_CHAP_WAITLIST_APPLIED);

/**
 * Updates the indicator of creation of details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesChapWaitlistAppliedReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_CHAP_WAITLIST_APPLIED);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesChapWaitlistAppliedErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_CHAP_WAITLIST_APPLIED);

/**
 * Updates the details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesChapWaitlistFundAvailableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE);

/**
 * Updates the indicator of creation of details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesChapWaitlistFundAvailableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesChapWaitlistFundAvailableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE);

/**
 * Updates the details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesChapWaitlistSubmitFormReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_CHAP_WAITLIST_SUBMIT_FORM);

/**
 * Updates the indicator of creation of details in the 'ACESWaitlist' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesChapWaitlistSubmitFormReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_CHAP_WAITLIST_SUBMIT_FORM);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesChapWaitlistSubmitFormErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_CHAP_WAITLIST_SUBMIT_FORM);

const reducers = combineReducers({
  postAcesChapWaitlistEnroll: postAcesChapWaitlistEnrollReducer,

  isFetchingPostAcesChapWaitlistEnroll: isFetchingPostAcesChapWaitlistEnrollReducer,
  postAcesChapWaitlistEnrollError: postAcesChapWaitlistEnrollErrorReducer,

  fetchAcesChapWaitlistApplied: fetchAcesChapWaitlistAppliedReducer,

  isFetchingFetchAcesChapWaitlistApplied: isFetchingFetchAcesChapWaitlistAppliedReducer,
  fetchAcesChapWaitlistAppliedError: fetchAcesChapWaitlistAppliedErrorReducer,

  fetchAcesChapWaitlistFundAvailable: fetchAcesChapWaitlistFundAvailableReducer,

  isFetchingFetchAcesChapWaitlistFundAvailable: isFetchingFetchAcesChapWaitlistFundAvailableReducer,
  fetchAcesChapWaitlistFundAvailableError: fetchAcesChapWaitlistFundAvailableErrorReducer,

  postAcesChapWaitlistSubmitForm: postAcesChapWaitlistSubmitFormReducer,

  isFetchingPostAcesChapWaitlistSubmitForm: isFetchingPostAcesChapWaitlistSubmitFormReducer,
  postAcesChapWaitlistSubmitFormError: postAcesChapWaitlistSubmitFormErrorReducer,
});

export default { reducers };
